import { useScreenWidth } from 'hooks/useScreenWidth';
import logo from '../../../assets/bigLogo.svg';
import regImg from '../../../assets/registerImg.png';
import { Link } from 'react-router-dom';
const RegForm = ({ children }) => {
    const screen = useScreenWidth();
    return (
        <div className="reg-form">
            {screen > 767 && (
                <div className="reg-form-img">
                    <Link to="/">
                        <img src={logo} alt="logo" className="logo" />
                    </Link>
                    <h1>Start Your Journey to Entrepreneurship</h1>
                    <img src={regImg} alt="reg-img" className="img-reg" />
                </div>
            )}
            {children}
        </div>
    );
};

export default RegForm;
